import dateFormat from "dateformat";

const FONT_SIZE = window.innerWidth * 0.25;

class ClockCanvas {
  private canvas = document.createElement("canvas");
  private ctx: CanvasRenderingContext2D;

  constructor() {
    this.ctx = this.canvas.getContext("2d", {
      willReadFrequently: true,
    }) as CanvasRenderingContext2D;

    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;
    this.canvas.style.position = "fixed";
    this.canvas.style.top = "0";
    this.canvas.style.left = "0";
    this.canvas.style.zIndex = "99";
    this.canvas.style.width = `100px`;
    this.canvas.style.height = `100px`;
    this.canvas.style.border = "1px solid red";

    // document.body.appendChild(this.canvas);
    this.getImageData();
  }

  public getImageData(): ImageData {
    const string = dateFormat(new Date(), "HH:MM:ss");
    this.ctx.font = `normal normal bold ${FONT_SIZE}px/${FONT_SIZE}px Terminal Grotesque`;
    // this.ctx.font = "normal normal normal 90px/90px Terminal Grotesque";
    this.ctx.textAlign = "center";
    this.ctx.fillStyle = "black";
    this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    this.ctx.strokeStyle = "white";
    this.ctx.fillStyle = "white";
    this.ctx.lineWidth = 1;

    this.ctx.strokeText(
      string,
      this.canvas.width / 2,
      this.canvas.height / 2 + FONT_SIZE * 0.25
    );

    // const bitmap = await createImageBitmap(this.canvas, {
    //   resizeWidth: window.innerWidth * window.devicePixelRatio,
    //   resizeHeight: window.innerHeight * window.devicePixelRatio,
    //   resizeQuality: "pixelated",
    // });

    const imageData = this.ctx.getImageData(
      0,
      0,
      this.canvas.width,
      this.canvas.height
    );

    return imageData as ImageData;
  }

  public get width(): number {
    return this.canvas.width;
  }

  public get height(): number {
    return this.canvas.height;
  }
}

export default ClockCanvas;
